import { useLocationTop10Query } from '@/hooks/RQHooks/tour/main/useLocationTop10Query';
import ExperienceProductCarousel from './ExperienceProductCarousel';
export default function LocationTop10List({ location }: { location: string }) {
  const { data, isPending } = useLocationTop10Query(location);

  return <ExperienceProductCarousel products={data ?? []} />;
}
